import React from 'react';
import s from './login.module.css';
import { BRAND } from '../../domain/brand';

const ENV_KEYS = [
  'VITE_FIREBASE_API_KEY',
  'VITE_FIREBASE_AUTH_DOMAIN',
  'VITE_FIREBASE_PROJECT_ID',
  'VITE_FIREBASE_STORAGE_BUCKET',
  'VITE_FIREBASE_MESSAGING_SENDER_ID',
  'VITE_FIREBASE_APP_ID',
];

// Shown instead of the sign-in form when Firebase has no configuration. There
// is nothing to sign in to, so it explains the setup rather than presenting a
// form that cannot work.
export default function SetupRequired() {
  return (
    <div className={s.setupPage}>
      <div className={s.setupCard}>
        <div className={s.markLarge} />
        <h1 className={s.setupTitle}>Welcome to {BRAND.name}</h1>
        <p className={s.setupLead}>
          Firebase is not configured yet. Please set up your environment variables.
        </p>

        <div className={s.envBlock}>
          <p className={s.envCaption}>.env (create from .env.example)</p>
          <div className={s.envKeys}>
            {ENV_KEYS.map((k) => <div key={k}>{k}=...</div>)}
          </div>
        </div>

        <p className={s.setupHint}>
          Copy <code className={s.code}>.env.example</code> to <code className={s.code}>.env</code> and
          fill in your Firebase project credentials, then restart the dev server.
        </p>
      </div>
    </div>
  );
}
